import { Component, OnInit } from '@angular/core';
import { LogoutService } from 'src/app/services/logout/logout.service';
import { Navigator } from 'src/app/components/menu/navigator';
import { UtilsService } from 'src/app/services/utils/utils.service';

@Component({
  selector: 'app-cams',
  templateUrl: './cams.component.html',
  styleUrls: ['./cams.component.scss'],
})
export class CamsComponent implements OnInit {

  constructor(
    private navigator: Navigator,
    private logoutService: LogoutService,
    private utils:UtilsService
  ) { }

  ngOnInit() {}

  goToIDNow = () => {
    this.navigator.navigateTo("IdNowComponent", { forceModal: true });
  }

  closeModal = () => {
    this.logoutService.onLogout({reason:'QUALIFICATION_ID_SCAN_UNFINISHED'});
  }

}
